import React, { useEffect, useState } from 'react';
import { useGenerateCouponCode } from './hooks';
import { useSelector } from 'react-redux';
import { Header, WrapDataGrid } from 'components/DataGrid/Style';
import { Table } from 'components';
import { dataGridModel, features } from 'keys';
import { WrapHeader, TablePageStyles } from 'styles/GlobalStyle'
import { testTakerHooks } from '.'
import { queryClient as qc } from 'keys';
import { getTestTakers3Fetch } from 'store/middlewares/testTakers.crud';
import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query';
import { initialPage, initialPageSize } from 'keys/pagination';
import { Can } from 'components/Permissions';
import { permissions } from 'config/ability';
import { Button } from 'components/Form';
import { keys, pickBy } from 'lodash';
import { getCurrentSchoolYear } from 'utils/general';
import AssignTestTakersToLearningGroupAlert from './AssignTestTakersToLearningGroupAlert';

const TestTakers = () => {
    const { headerFilters } = useSelector(state => state.header)
    const { testTaker } = useSelector(state => state.testTaker)

    const filterSchema = {
        primary: [{ key: "school_year" }]
    };

    const [filters, setFilters] = useState({
        school_year: getCurrentSchoolYear()
    })
    const [page, setPage] = useState(initialPage)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")
    const [selectedRowIds, setSelectedRowIds] = useState({})
    const [isAssignToGroupAlertOpen, setIsAssignToGroupAlertOpen] = useState(false)

    const selectedTestTakerIds = keys(pickBy(selectedRowIds, v => v === true))

    useEffect(() => {
        setSelectedRowIds({})
    }, [page, pageSize])

    const generateCouponCodeBtn = useGenerateCouponCode()

    const columns = testTakerHooks.useColumns()
    const headerBtns = testTakerHooks.useHeaderBtns()

    const testTakersOptions = queryOptions({
        queryKey: [qc.getWithLastAssessments, page, pageSize, sorting, searchVal, headerFilters, testTaker, filters],
        queryFn: async () => {
            const { data } = await getTestTakers3Fetch({ headerFilters, page, pageSize, filters, search: searchVal, sorting, model: qc.getWithLastAssessments })
            return data
        }
    })

    const testTakers = useQuery(testTakersOptions)

    useEffect(() => {
        setPage(initialPage)
    }, [headerFilters])

    return (
        <TablePageStyles>
            <Table
                filterSchema={filterSchema}
                filterValues={filters}
                onFilterChange={setFilters}
                withTitle
                loading={testTakers.isFetching && !testTakers.data}
                data={testTakers.data}
                columns={columns}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                rowKey={"test_taker_id"}
                uniqueId={"test_taker_id"}
                visibilityModelKey={dataGridModel.test_takers}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
                sorting={sorting}
                setSorting={setSorting}
                queryKey={testTakersOptions.queryKey}
                selectedRowIds={selectedRowIds}
                onRowSelection={setSelectedRowIds}
                customToolbar={
                    <Can I={permissions.read} a={features.school_setup}>
                        <Button
                            disabled={!selectedTestTakerIds.length}
                            action={() => setIsAssignToGroupAlertOpen(true)}
                            color="thirdly"
                            label="שיוך תלמידים לקבוצות למידה"
                        />
                    </Can>
                }
            />
            {isAssignToGroupAlertOpen &&
                <AssignTestTakersToLearningGroupAlert
                    selectedTestTakerIds={selectedTestTakerIds}
                    handleAlert={() => setIsAssignToGroupAlertOpen(false)}
                    onAssigned={() => setSelectedRowIds({})}
                />}
        </TablePageStyles>
    )
}

export default TestTakers
